export default class PasswordRecoveryFormValidation {
	static readonly codeLength = 6
}
